// 该文件专门用于创建整个应用的路由器
import Router from 'vue-router'
//引入组件
import Home from '../pages/Home'
import Detail from '../pages/Detail'
import Theme from '../pages/Theme'
import Search from '../pages/Search'
import Download from '../pages/Download'
import About from '../pages/About'
import NotFound from '../pages/NotFound'


//创建并暴露一个路由器
const router = new Router({
	// base: '/temp/',  
	mode: 'history',
	routes: [
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '*',
			component: NotFound,
			// meta:{
			// 	hideHeader: true,
			// 	hideFooter: true
			// },
		},
		{
			path: '/home',
			component: Home,
			meta:{
				keepAlive: true
			},
		},
		{
			path: '/search',
			component: Search,
			meta:{
				hideSearch: true,
				keepAlive: true
			},
		},
		{
			name: 'theme',
			path: '/theme',
			component: Theme,
			meta:{
				keepAlive: true
			},
		},
		{	
			name: 'detail',
			path: '/detail',
			component: Detail,
		},
		{
			path: '/download',
			component: Download,
		},
		{
			path: '/about',
			component: About,
		},
	],
})
router.beforeEach((to,from,next)=>{
    let position = window.scrollY; //记录离开页面的位置 
    if (position == null) position = 0;
    sessionStorage.setItem(from.name,window.scrollY);
    next() 
});

router.afterEach((to, from) => {
	let scrollY = sessionStorage.getItem(to.name);
	if(scrollY){
		window.scrollTo(0,scrollY);//定位页面上次滚动的位置
	}else{
		window.scrollTo(0,0);
	}
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
